import { z } from "zod";

export const zSystemAttributeType = z.enum([
  "createdDate", // дата создания
  "updatedDate", // дата изменения
  "createdBy", // автор создания
  "updatedBy", // автор изменения
]);
export type ZSystemAttributeType = z.infer<typeof zSystemAttributeType>;
